import store from '..';

import {
    setProjectElements,
    setSelectedMeshId,
    setSelectedMesh,
    setSelectedProjectElementId,
    setIsOptimizedView,
    setSelectedReference
} from '../actions/Project';

export const setElements = (elements) => {
    store.dispatch(setProjectElements(elements));
};

export const setMeshId = (id) => {
    store.dispatch(setSelectedMeshId(id));
};

export const setMesh = (selectedMesh) => {
    store.dispatch(setSelectedMesh(selectedMesh));
};

export const setProjectElementId = (id) => {
    store.dispatch(setSelectedProjectElementId(id));
};

export const setOptimizedView = (value) => {
    store.dispatch(setIsOptimizedView(value));
};

export const setReference = (value) => {
    store.dispatch(setSelectedReference(value));
};
